import { toNewsPost } from '../models/mapper'
import { NewsPost, NewsPostCreateRequest } from '../models/types'
import { createNewsPostV1 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createNewsPost(request: NewsPostCreateRequest): Promise<NewsPost> {
  return toNewsPost(await createNewsPostV1(request))
}
